// *** TRANSLATION VARIABLES (ENGLISH, FINNISH, SWEDISH) ***

export default {
    en: {
        account: 'Account',
        account_updated: 'Account updated',
        activate: 'Activate',
        active: 'Active',
        add_another_medication: 'Add another medication',
        add_comment: 'Comment',
        add_comment_to_log: 'Add comment to log',
        add_drugsafe_user: 'Add DrugSafe user',
        add_medication: 'Add medication',
        add_time: 'Add time',
        add_to_reservation: 'Add to reservation',
        alarm_email: 'Alarm e-mail',
        alarm_phone: 'Alarm phone',
        alarm: 'Alarm',
        alarms: 'Alarms',
        alert_expires_in_less_than: 'Expires in less than ',
        alert_low_inventory: 'Low inventory',
        alert_threshold: 'Alert threshold',
        alert_time: 'Alert time',
        all: 'All',
        amount: 'Amount',
        amount_added: 'Added',
        amount_locker: 'In locker',
        amount_taken: 'Taken',
        appear_soon: 'Expecting PIN',
        atc: 'ATC code',
        available: 'Available',
        back: 'Back',
        before_expiry: 'before expiry',
        big_no_fridge: 'Big, no fridge',
        big_with_fridge: 'Big with fridge',
        business_id: 'Business ID',
        cancel: 'Cancel',
        careful: 'Careful',
        center: 'Center',
        center_type: 'Center type',
        change: 'Inventory correction',
        change_password_drugsafeuser: 'DrugSafe PIN',
        change_password_webuser: 'WebTool account password',
        changes: 'Changes',
        check: 'Inventory check',
        chemical: 'Active ingredient',
        choose_layout: 'Choose layout',
        city: 'City',
        client: 'Client',
        client_name: 'Client name',
        close: 'Close',
        comments: 'Comments',
        confirm: 'Confirm',
        confirm_new_password: 'Confirm new password',
        confirm_new_pin: 'Confirm new PIN',
        confirm_password: 'Confirm password',
        correction_legend: 'Corrections are marked with an asterisk (*); original value in parentheses.',
        country: 'Country',
        create: 'Create',
        create_custom_medication: 'Create custom medication',
        create_drugsafe_user: 'Create DrugSafe user',
        create_only_drugsafe_user: 'Create only DrugSafe user',
        create_only_web_user: 'Create only web user',
        create_pharmacy: 'Create pharmacy',
        create_reservation: 'Create reservation',
        create_user: 'Create user',
        create_web_and_drugsafe_users: 'Create web and DrugSafe users',
        create_web_user: 'Create web user',
        created: 'Created',
        created_at: 'Created at',
        current_inventory: 'Current inventory at time of printing:',
        current_password: 'Current password',
        current_pin: 'Current PIN',
        custom_medication_cannot_delete_in_use:
            'This custom medication cannot be deleted because it is already in use.',
        custom_medication_cannot_edit_in_use: 'This custom medication cannot be edited because it is already in use.',
        custom_medication_created: 'Custom medication created',
        custom_medication_deleted: 'Custom medication deleted',
        custom_medication_updated: 'Custom medication updated',
        custom_medication_vnr_tooltip: `P + six digits, e.g. P000001`,
        custom_medications: 'Custom Medications',
        dashboard: 'Dashboard',
        date: 'Date',
        days: 'days',
        deactivate: 'Deactivate',
        default_locker: 'Default locker',
        default_locker_not_set: 'Default locker not set',
        default_locker_set: 'Default locker set',
        default_lockers: 'Default lockers',
        default_lockers_tooltip: `Save medications' default lockers into memory. If the setting is on, the DrugSafe helps the user add each medication to the correct locker. Default lockers can be changed on the Medication List page.`,
        delete: 'Delete',
        delete_custom_medication_are_you_sure_text: 'Are you sure you want to delete this custom medication?',
        delete_custom_medication_are_you_sure_title: 'Delete custom medication?',
        delete_drugsafe_user_are_you_sure: 'Are you sure you want to delete this DrugSafe user?',
        delete_drugsafe_user_are_you_sure_title: 'Delete DrugSafe user?',
        delete_old_logs: 'Automatic deletion of old logs',
        delete_old_logs_are_you_sure_text: `You have set automatic deletion of old logs to 'on'. This will irreversibly delete log entries older than the statutory minimum retention period. Are you sure you want to proceed?`,
        delete_old_logs_are_you_sure_title: 'Switch on automatic deletion of old logs?',
        delete_old_logs_tooltip:
            'If the setting is on, old log entries are automatically deleted after the statutory minimum retention period (six full calendar years).',
        delete_own_web_user_are_you_sure: `Are you sure you want to delete your own web user? If you proceed, you will be automatically logged out and won't be able to log in again.`,
        delete_own_web_user_are_you_sure_title: 'Delete own web user?',
        delete_pharmacy_are_you_sure_text: 'Are you sure you want to delete this pharmacy and all its web users?',
        delete_pharmacy_are_you_sure_title: 'Delete pharmacy?',
        delete_reservation_are_you_sure_text: 'Are you sure you want to delete this reservation?',
        delete_reservation_are_you_sure_title: 'Delete reservation?',
        delete_role: 'Are you sure you want to delete this role?',
        delete_web_user_are_you_sure: 'Are you sure you want to delete this web user?',
        delete_web_user_are_you_sure_title: 'Delete web user?',
        delete_web_user_alert_recipient_prompt_1:
            'Note: the user is currently set as the recipient for the following e-mail alerts:',
        delete_web_user_alert_recipient_prompt_2:
            'Deleting the user will disable these alerts until another recipient is set.',
        description: 'Description',
        doctor: 'Doctor',
        doctor_name: 'Doctor name',
        dosage: 'Dosage',
        dosage_tworows: 'Dosage',
        dosage_form: 'Dosage form',
        dosage_form_tworows: 'Dosage form',
        dosage_tooltip: 'Amount + unit',
        drug: 'Drug',
        drug_card: 'Drug Card',
        drug_tworows: 'Drug',
        drugsafe: 'DrugSafe',
        drugsafe_structure: 'DrugSafe structure',
        drugsafe_user: 'DrugSafe user',
        drugsafe_user_created: 'DrugSafe user created',
        drugsafe_user_deleted: 'DrugSafe user deleted',
        drugsafe_user_updated: 'DrugSafe user updated',
        drugsafe_users: 'DrugSafe users',
        earliest_expiry_date: 'Earliest expiry date',
        edit: 'Edit',
        edit_custom_medication: 'Edit custom medication',
        edit_drugsafe_user: 'Edit DrugSafe user',
        edit_log: 'Edit Log',
        edit_pharmacy: 'Edit pharmacy',
        edit_reservation: 'Edit reservation',
        edit_web_user: 'Edit web user',
        email: 'E-mail',
        email_sent: 'E-mail sent',
        error: 'Error',
        error_account_temporarily_disabled:
            'The account is temporarily disabled. Please try again later or contact the service administrator.',
        error_amount_required: 'Specify amount (in packages and/or individual pieces)',
        error_cannot_be_negative: 'The value cannot be negative',
        error_cannot_edit_signed_log: 'The log cannot be edited because it has been signed.',
        error_confirmation: 'Values do not match',
        error_could_not_check_expiry_alerts: 'Could not check medication expiry alert info',
        error_could_not_check_pin: 'Could not check PIN',
        error_could_not_create_custom_medication: 'Could not create custom medication',
        error_could_not_create_drugsafe_user: 'Could not create DrugSafe user',
        error_could_not_create_firebase_auth_user: 'Could not create Firebase Authentication user',
        error_could_not_create_login_logout_log: 'Could not create login/logout log',
        error_could_not_create_pharmacy: 'Could not create pharmacy',
        error_could_not_create_pin: 'Could not create PIN',
        error_could_not_create_reservation: 'Could not create reservation',
        error_could_not_create_web_user: 'Could not create web user',
        error_could_not_decrypt: 'Content decryption failed',
        error_could_not_delete_custom_medication: 'Could not delete custom medication',
        error_could_not_delete_default_locker: 'Could not delete default locker',
        error_could_not_delete_firebase_auth_user: 'Could not delete Firebase Authentication user',
        error_could_not_delete_gtin_vnr_pairs: 'Could not delete GTIN–VNR pairs',
        error_could_not_delete_medication_alert_config: 'Could not delete medication alert config',
        error_could_not_delete_medications: 'Could not delete medications',
        error_could_not_delete_old_logs: 'Could not delete old logs',
        error_could_not_delete_pharmacy: 'Could not delete pharmacy',
        error_could_not_delete_drugsafe_user: 'Could not delete DrugSafe user',
        error_could_not_delete_reservation: 'Could not delete reservation',
        error_could_not_delete_web_user: 'Could not delete WebTool user',
        error_could_not_delete_web_users: 'Could not delete WebTool users',
        error_could_not_encrypt: 'Content encryption failed',
        error_could_not_generate_password_reset_link: 'Could not generate password reset link',
        error_could_not_get_alarms: 'Could not get alarms',
        error_could_not_get_available_amount: 'Could not get available amount',
        error_could_not_get_custom_medication: 'Could not get custom medication',
        error_could_not_get_custom_medications: 'Could not get custom medications',
        error_could_not_get_default_locker: 'Could not get default locker',
        error_could_not_get_default_lockers: 'Could not get default lockers',
        error_could_not_get_drugsafe_config: 'Could not get DrugSafe configuration',
        error_could_not_get_drugsafe_languages: 'Coult not get DrugSafe languages',
        error_could_not_get_drugsafe_user: 'Could not get DrugSafe user',
        error_could_not_get_drugsafe_users: 'Could not get DrugSafe users',
        error_could_not_get_firebase_auth_user: 'Could not get Firebase Authentication user',
        error_could_not_get_freezes: 'Could not get locked medications',
        error_could_not_get_gtin_vnr_pairs: 'Could not get GTIN–VNR pairs',
        error_could_not_get_log: 'Could not get log',
        error_could_not_get_logs: 'Could not get logs',
        error_could_not_get_medication: 'Could not get medication',
        error_could_not_get_medication_alert_config: 'Could not get medication alert config',
        error_could_not_get_medication_db_update_date: 'Could not get medication database update date',
        error_could_not_get_medications: 'Could not get medications',
        error_could_not_get_password_reset_link: 'Could not get password reset link',
        error_could_not_get_pharmacies: 'Could not get pharmacies',
        error_could_not_get_pharmacy: 'Could not get pharmacy',
        error_could_not_get_reservation: 'Could not get reservation',
        error_could_not_get_reservations: 'Could not get reservations',
        error_could_not_get_role: 'Could not get role',
        error_could_not_get_roles: 'Could not get roles',
        error_could_not_get_web_user: 'Could not get WebTool user',
        error_could_not_get_web_users: 'Could not get WebTool users',
        error_could_not_handle_failed_login: 'Could not handle failed login',
        error_could_not_send_email: 'Could not send e-mail',
        error_could_not_set_default_locker: 'Could not set default locker',
        error_could_not_set_gtin_vnr_pairs: 'Could not set GTIN–VNR pairs',
        error_could_not_set_medications: 'Could not set medications',
        error_could_not_set_medication_db_update_date: 'Could not set medication database update date',
        error_could_not_update_custom_medication: 'Could not update custom medication',
        error_could_not_update_default_locker: 'Could not update default locker',
        error_could_not_update_drugsafe_user: 'Could not update DrugSafe user',
        error_could_not_update_firebase_auth_user: 'Could not update Firebase Authentication user',
        error_could_not_update_log: 'Could not update log',
        error_could_not_update_password: 'Could not update password',
        error_could_not_update_pharmacy: 'Could not update pharmacy',
        error_could_not_update_reservation: 'Could not update reservation',
        error_could_not_update_pin: 'Could not update PIN',
        error_could_not_update_web_user: 'Could not update WebTool user',
        error_custom_vnr_format: `VNR must be given as 'P' followed by six digits, e.g. P000001`,
        error_drugsafe_user_not_found: 'No users found',
        error_duplicate_vnr: 'Medication already in reservation',
        error_email_taken: 'E-mail address is already taken',
        error_field_required: 'Required field',
        error_field_required_if_alert_threshold_specified: 'The field is required if an alert threshold is specified.',
        error_field_required_if_alert_time_specified: 'The field is required if an alert time is specified.',
        error_field_required_if_recipient_specified: 'The field is required if a recipient is specified.',
        error_invalid_data: 'Invalid data',
        error_login_too_many_attempts:
            'Too many incorrect login attempts. Please try again later or contact the service administrator.',
        error_login_user_not_found: 'User account not found',
        error_login_wrong_password: 'Wrong password',
        error_med_name_not_found: 'Medication not found by name; try to search for it by VNR',
        error_must_be_integer: 'The value must be an integer',
        error_name_vnr_missing: 'Specify the name or VNR of the drug',
        error_network_server_error:
            'Network or server error. Please try again later or contact the service administrator.',
        error_not_positive: 'The value must be positive',
        error_permission_denied: 'Permission denied',
        error_pin_not_unique: 'PIN must be unique',
        error_prescription_in_use: 'One of the prescription numbers is already in use in another reservation',
        error_prescription_not_unique: 'Prescription number must be unique',
        error_reservation_locked: 'The reservation cannot be edited because it is currently being claimed.',
        error_session_expired: 'Your session has expired. Please log in again.',
        error_supplier_missing: 'Specify supplier before printing',
        error_too_long: 'Length can be at most ',
        error_too_short: 'Length must be at least ',
        error_valid_email: 'Must be a valid e-mail address',
        error_value_too_high: 'The value can be at most ',
        error_value_too_low: 'The value must be at least ',
        error_vnr_not_found: 'VNR not found',
        error_vnr_not_found_in_used_meds: 'No events found for VNR.',
        error_vnr_not_found_try_to_get_from_list: 'Try to get information about medication from Medication List, if this VNR was used',
        error_vnr_not_unique: 'VNR must be unique',
        error_web_user_inactive: 'The user account is inactive. Please ask a main user to active the account.',
        error_web_user_not_found: 'WebTool user not found',
        error_web_user_not_free: 'WebTool user not free',
        error_wrong_length: 'Length must be ',
        expiry_alert_recipient_tooltip: 'Select the user to whom expiry alert e-mails will be sent.',
        expiry_alert_time_tooltip: 'Specify how long before expiry the alerts will be sent.',
        expiry_alerts: 'Medication expiry alerts',
        expiry_date: 'Expiry date',
        field: 'Field',
        field_cannot_edit_later: 'Cannot be edited later',
        field_required: 'Required field',
        filter: 'Filter',
        first_name: 'First name',
        firstname_lastname: 'Firstname Lastname',
        forgot_password: 'Order new password',
        form: 'Unit',
        from: 'From',
        full_packages_only: 'Do not split full packages. When chosen, DrugSafe processes full packages as full and does not build a full package out of partial packages.',
        full: 'Locker only opened',
        general_info: 'General info',
        generate: 'Generate',
        generate_pin: 'Generate\xa0PIN',
        global_search: 'Drug search',
        handler: 'Handler',
        hide_partial_packages: 'Hide partial packages',
        homepage: 'Homepage',
        hours_partitive: 'hours',
        id: 'ID',
        inactivate_own_web_user_are_you_sure: `Are you sure you want to inactivate your own web user account? If you proceed, you will be automatically logged out and won't be able to log in again until the account is reactivated.`,
        inactivate_own_web_user_are_you_sure_title: 'Inactivate own web user?',
        inactive: 'Inactive',
        include_med_in_res_title: 'Included unadded medication?',
        include_med_in_res_text: 'Do you want to include the medication MEDNAME in the reservation?',
        information: 'Information',
        inventory: 'Inventory',
        inventory_check: 'Inventory check',
        inventory_correction: 'Inventory correction',
        inventory_left: 'Inventory',
        is_required: 'is required',
        lang_en: 'English',
        lang_fi: 'Finnish',
        lang_sv: 'Swedish',
        language: 'Language',
        last_login_date: 'Last login date',
        last_name: 'Last name',
        last_put_in: 'Latest put\xa0in',
        location: 'Location',
        locker: 'Locker',
        log: 'Log',
        log_signed: 'Log signed',
        log_updated: 'Log updated',
        login: 'Log in',
        logo: 'Logo',
        logout: 'Logout',
        logs_and_alarms: 'Logs and alarms',
        logs: 'Logs',
        low_inventory_alert_recipient_tooltip: 'Select the user to whom low inventory alert e-mails will be sent.',
        low_inventory_alert_threshold: 'Low inventory alert threshold',
        low_inventory_alert_threshold_set: 'Low inventory alert set',
        low_inventory_alert_threshold_tooltip_default:
            'Specify the inventory amount at which an alert will be sent. This threshold applies to all medications for which a custom threshold has not been set. ' +
            'You can set medication-specific alert thresholds on the Medication List page.',
        low_inventory_alert_threshold_tooltip_medication_list:
            'The inventory amount (in packages) at which an alert will be sent. You can specify the recipient and a default alert threshold on the My Pharmacy page.',
        low_inventory_alerts: 'Low inventory alerts',
        mandatory_inventory_check: 'Mandatory inventory check',
        mandatory_inventory_check_tooltip: `Check the medication's inventory as part of each addition and removal.`,
        marketing_authorization_holder: 'Marketing authorization holder',
        marketing_authorization_holder_tworows: 'Marketing authorization holder',
        medical_center: 'Medical center',
        medication: 'Medication',
        medication_info: 'Medication Info',
        medication_list: 'Medication List',
        medication_name: 'Medication name',
        medications: 'Medications',
        meds_in_reservation: 'Medications in reservation',
        message: 'message',
        months: 'months',
        my_account: 'My account',
        my_pharmacy: 'My Pharmacy',
        name: 'Name',
        new_data: 'New data',
        new_password: 'New password',
        new_pin: 'New PIN',
        no: 'No',
        no_description: 'No description',
        no_logs: 'No actions for the specified interval.',
        no_selection: '(No selection)',
        none: 'None',
        not_available: 'Currently not available',
        ok: 'OK',
        or: 'or',
        order_new_password: 'Order new password',
        original: 'original',
        owner: 'Owner',
        owners: 'Owners',
        package_long: 'package',
        package_short: 'pkg',
        package_size: 'Package size',
        package_size_tworows: 'Package size',
        packages_left: 'Inventory',
        packages_long_plural_partitive: 'packages',
        packages_long_singular_partitive: 'packages',
        packages_pieces_short: 'pkgs\xa0(+\xa0pcs)',
        packages_pieces_tooltip: 'Full packages (+\xa0individual pieces in parentheses)',
        packages_pieces_tooltip_intro: 'Amount display format:',
        packages_pieces_tooltip_invcorr:
            '; for inventory corrections, the arrow indicates the direction of change (↑\xa0increase, ↓\xa0decrease)',
        packages_short_plural_partitive: 'pkgs',
        packages_short_singular_partitive: 'pkgs',
        page: 'Page',
        password: 'Password',
        patient_name: 'Kundnamn',
        per_page: 'Per page',
        permission_create_pharmacy: 'Create pharmacy',
        permission_create_user: 'Create user',
        permission_edit_pharmacy: 'Edit pharmacy',
        permission_edit_user: 'Edit user',
        permission_show_pharmacy: 'Show pharmacy',
        permission_show_user: 'Show user',
        permission_superadmin: 'ADMINISTRATÖR',
        permissions: 'Permissions',
        pharmacies: 'Pharmacies',
        pharmacy: 'Pharmacy',
        pharmacy_deleted: 'Pharmacy deleted',
        pharmacy_updated: 'Pharmacy updated',
        pharmacy_web_users_deleted: `Pharmacy's web users deleted`,
        piece_long: 'individual piece',
        piece_short: 'pc',
        pieces_long_plural_partitive: 'individual pieces',
        pieces_long_singular_partitive: 'individual pieces',
        pieces_short_singular_partitive: 'pcs',
        pin: 'PIN',
        pincode: 'PIN',
        pincode_confirm: 'Confirm PIN',
        preferences_updated: 'Preferences updated',
        prescription: 'Prescription number',
        prescription_number_already_in_use: 'Note: same prescription number used multiple times',
        print: 'Print',
        print_close: 'Print barcode and close',
        print_date: 'Print date',
        printed: 'Printed',
        put_in: 'Put in medication',
        recipient: 'Recipient',
        report: 'Report',
        reports: 'Reports',
        reseller: 'Reseller',
        reseller_tworows: 'Reseller',
        reservation: 'Claim reservation',
        reservation_cannot_set_pills: 'Individual pieces cannot be set for this medication.',
        reservation_created: 'Reservation created',
        reservation_created_for_vnr: 'Reservation created for VNR',
        reservation_deleted: 'Reservation deleted',
        reservation_id: 'Reservation ID',
        reservation_list_info: 'Items in red are not currently available in the inventory.',
        reservation_updated: 'Reservation updated',
        reservations: 'Reservations',
        reserved: 'Reserved',
        reset: 'Reset',
        role: 'Role',
        role_pharmacist: 'User',
        role_pharmacy_owner: 'Main user',
        role_superadmin: 'Superadmin',
        role_technician: 'Technician',
        roles_and_permissions: 'Roles and permissions',
        safe_type: 'DrugSafe type',
        salutation: 'Salutation',
        save: 'Save',
        saved: 'Saved',
        search: 'Search',
        searching: 'Searching...',
        select_pharmacy_or_medical_center: 'Select pharmacy or medical center',
        select: 'Select',
        send: 'Send',
        session_length: 'Session length',
        session_length_tooltip: `You can specify the length of time the user remains logged in (1–8 hours). If the field is left blank, the default session length (2 hours) is used.`,
        set_web_user_are_you_sure: 'Are you sure you want to associate this DrugSafe user with the following web user:',
        set_web_user_are_you_sure_title: 'Associate DrugSafe user with web user?',
        show_drugsafe_user: 'Show DrugSafe user',
        show_inventory_check_column: `Show "Inventory check" column`,
        show_log: 'Show log',
        show_partial_packages: 'Show partial packages',
        show_pharmacy: 'Show pharmacy',
        show_web_user: 'Show web user',
        show: 'Show',
        sign: 'Sign',
        sign_log_are_you_sure_text:
            'Are you sure you want to sign this log? After signing, the log can no longer be edited.',
        sign_log_are_you_sure_title: 'Sign log?',
        signed: 'Signed',
        signed_by: 'Signed by',
        slug: 'Slug',
        small_no_fridge: 'Small, no fridge',
        small_with_fridge: 'Small with fridge',
        status: 'Status',
        street: 'Street',
        submit: 'Submit',
        supplier: 'Supplier',
        take_out: 'Take out medication',
        time_at: 'at',
        time_period: 'Time period',
        time_period_selection: 'Select time unit',
        time_period_selection_days: 'days',
        time_period_selection_months: 'months',
        time_period_selection_weeks: 'weeks',
        to: 'To',
        two_d_codes: '2D codes',
        type: 'Type',
        update_account: 'Update account info',
        update_drug_card_inv_check_col_common_text: `You can also set the column visibility in the Drug Card layout settings.`,
        update_drug_card_inv_check_col_hide_text: `You have switched off the mandatory inventory check, but the "Inventory check" column is currently shown on the Drug Card. Do you want to hide the column?`,
        update_drug_card_inv_check_col_hide_title: `Hide "Inventory check" column on Drug Card?`,
        update_drug_card_inv_check_col_show_text: `You have switched on the mandatory inventory check, but the "Inventory check" column is currently hidden on the Drug Card. Do you want to show the column?`,
        update_drug_card_inv_check_col_show_title: `Show "Inventory check" column on Drug Card?`,
        update_reservation: 'Update reservation',
        updated_at: 'Updated at',
        users: 'Users',
        users_amount: 'Users',
        users_data: 'User data',
        value: 'Value',
        view_individual_meds_same_column: 'Packages and individual pieces in same column',
        view_individual_meds_separate_column: 'Packages and individual pieces in separate columns',
        vnr: 'VNR',
        web_user: 'Web user',
        web_user_created: 'Web user created',
        web_user_deleted: 'Web user deleted',
        web_user_updated: 'Web user updated',
        web_users: 'Web users',
        yes: 'Yes',
        zip: 'Postal code',
        error_switch_to_syke_mode: 'Switch to new Webtool link https://drugsafe-remomedi-syke.web.app',
        many_incorrect_logins: 'Many incorrect logins',
        enable_account: 'Enable account',
        activate_account: 'Activate account',
        deactivated: 'Deactivated',
        minutes_partitive: 'minutes',

        take_out_action_may_be_destroy_of_medication: 'If this take out action was a destroy of medication please mark it as destroyed and sign. Note! The log should have client, doctor and prescription number fields empty',
        i_give_consent_that_i_mark_action_as_destroy: 'I explicitly give consent that I mark this take out action as destroy of medication',
        update_and_sign: 'Update Log as destroy & Sign',
        mark_log_as_destroyed_title: 'Are you sure you want to mark this log as destroy of medication?',
        mark_log_as_destroyed_question: 'Attention! This action is irreversible. Are you sure you want to mark this take out of the medication as a log of destroy? You can not cancel this action later.',
        error_cannot_edit_destroyed_log: 'The log cannot be edited because it has been marked as destroyed.',
        error_cannot_edit_signed_and_marked_log: 'The log cannot be edited because it has been marked as destroyed and signed.',
        mark_destroy_user_and_time: 'Date&Time, User who marked and signed the destroy of medication',
        comments_to_destroyed_drugs: 'Please, use the fields comments on the left side to add description of the action',

        additional_modules: 'Additional modules',
        add_module: 'Add module',
        choose_module_to_remove: 'Choose module to remove',
        remove_module: 'Remove module',
        remove: 'Remove',
        error_could_not_change_structure_medication_in_locker: 'Pharmacy has inventory in this module. Can not remove it'
    },
    fi: {
        account: 'Tili',
        account_updated: 'Tili päivitetty',
        activate: 'Aktivoi',
        active: 'Aktiivinen',
        add_another_medication: 'Lisää toinen lääke',
        add_comment: 'Kommentoi',
        add_comment_to_log: 'Lisää kommentti lokiin',
        add_drugsafe_user: 'Lisää DrugSafe-käyttäjä',
        add_medication: 'Lisää lääke',
        add_time: 'Lisää aika',
        add_to_reservation: 'Lisää varaukseen',
        alarm_email: 'Hälytysten sähköposti',
        alarm_phone: 'Hälytysten puhelinnumero',
        alarm: 'Hälytys',
        alarms: 'Hälytykset',
        alert_expires_in_less_than: 'Voimassa alle ',
        alert_low_inventory: 'Saldo vähissä',
        alert_threshold: 'Hälytysraja',
        alert_time: 'Hälytysajankohta',
        all: 'Kaikki',
        amount: 'Määrä',
        amount_added: 'Lisätty',
        amount_locker: 'Lokerossa',
        amount_taken: 'Otettu',
        appear_soon: 'Odottaa',
        atc: 'ATC-koodi',
        available: 'Vapaana',
        back: 'Palaa',
        before_expiry: 'ennen vanhenemista',
        big_no_fridge: 'Suuri ilman jääkaappia',
        big_with_fridge: 'Suuri jääkaapilla',
        business_id: 'Y-tunnus',
        cancel: 'Peruuta',
        careful: 'Caution',
        center: 'Keskus',
        pharmacy_data: 'Perustiedot',
        center_type: 'Keskustyyppi',
        change: 'Saldon korjaus',
        change_password_drugsafeuser: 'DrugSafen PIN-koodi',
        change_password_webuser: 'Hallintaohjelman salasana',
        changes: 'Muutokset',
        check: 'Saldon tarkistus',
        chemical: 'Vaikuttava aine',
        choose_layout: 'Valitse ulkoasu',
        city: 'Kaupunki',
        client: 'Asiakas',
        client_name: 'Asiakkaan nimi',
        close: 'Sulje',
        comments: 'Kommentit',
        confirm: 'Vahvista',
        confirm_new_password: 'Vahvista uusi salasana',
        confirm_new_pin: 'Vahvista uusi PIN',
        confirm_password: 'Vahvista salasana',
        correction_legend: 'Korjaukset on merkattu tähdellä (*); alkuperäinen arvo suluissa.',
        country: 'Maa',
        create: 'Luo',
        create_custom_medication: 'Luo poikkeuslääke',
        create_drugsafe_user: 'Luo DrugSafe-käyttäjä',
        create_only_drugsafe_user: 'Luo vain DrugSafe-käyttäjä',
        create_only_web_user: 'Luo vain hallintaohjelman käyttäjä',
        create_pharmacy: 'Luo uusi apteekki',
        create_reservation: 'Luo varaus',
        create_user: 'Luo käyttäjä',
        create_web_and_drugsafe_users: 'Lue hallintaohjelma- ja DrugSafe-käyttäjät',
        create_web_user: 'Luo hallintaohjelman käyttäjä',
        created: 'Luotu',
        created_at: 'Luotu',
        current_inventory: 'Saldo tulostushetkellä:',
        current_password: 'Nykyinen salasana',
        current_pin: 'Nykyinen PIN',
        custom_medication_cannot_delete_in_use: 'Tätä poikkeuslääkettä ei voi poistaa koska se on jo käytössä.',
        custom_medication_cannot_edit_in_use: 'Tätä poikkeuslääkettä ei voi muokata koska se on jo käytössä.',
        custom_medication_created: 'Poikkeuslääke luotu',
        custom_medication_deleted: 'Poikkeuslääke poistettu',
        custom_medication_updated: 'Poikkeuslääke päivitetty',
        custom_medication_vnr_tooltip: `P + kuusi numeroa, esim. P000001`,
        custom_medications: 'Poikkeuslääkkeet',
        dashboard: 'Päävalikko',
        date: 'Pvm',
        days: 'päivää',
        deactivate: 'Deaktivoi',
        default_locker: 'Oletuslokero',
        default_locker_not_set: 'Ei oletuslokeroa',
        default_locker_set: 'Oletuslokero asetettu',
        default_lockers: 'Oletuslokerot',
        default_lockers_tooltip: `Tallenna muistiin lääkkeiden oletuslokerot. Jos toiminto on päällä, DrugSafe-käyttöliittymä ohjaa lisäämään lääkkeen ensisijaisesti sen oletuslokeroon. Oletuslokeroita voi muuttaa Lääkelista-sivulla.`,
        delete: 'Poista',
        delete_custom_medication_are_you_sure_text: 'Oletko varma että haluat poistaa poikkeuslääkkeen?',
        delete_custom_medication_are_you_sure_title: 'Poistetaanko poikkeuslääke?',
        delete_drugsafe_user_are_you_sure: 'Oletko varma että haluat poistaa DrugSafe-käyttäjän?',
        delete_drugsafe_user_are_you_sure_title: 'Poistetaanko DrugSafe-käyttäjä?',
        delete_old_logs: 'Vanhojen lokien automaattinen poisto',
        delete_old_logs_are_you_sure_text:
            'Olet asettanut vanhojen lokien automaattisen poiston päälle. Tämä asetus poistaa peruuttamattomasti lakisääteistä minimisäilytysaikaa vanhemmat lokimerkinnät. Oletko varma että haluat jatkaa?',
        delete_old_logs_are_you_sure_title: 'Asetetaanko vanhojen lokien automaattinen poisto päälle?',
        delete_old_logs_tooltip:
            'Jos toiminto on päällä, vanhat lokimerkinnät poistetaan automaattisesti lakisääteisen minimisäilytysajan (kuusi täyttä kalenterivuotta) jälkeen.',
        delete_own_web_user_are_you_sure:
            'Oletko varma että haluat poistaa oman hallintaohjelmakäyttäjäsi? Jos jatkat, sinut kirjataan automaattisesti ulos etkä voi enää kirjautua sisään.',
        delete_own_web_user_are_you_sure_title: 'Poistetaanko oma hallintaohjelman käyttäjä?',
        delete_pharmacy_are_you_sure_text:
            'Oletko varma että haluat poistaa apteekin ja kaikki sen hallintaohjelmakäyttäjät?',
        delete_pharmacy_are_you_sure_title: 'Poistetaanko apteekki?',
        delete_reservation_are_you_sure_text: 'Oletko varma että haluat poistaa varauksen?',
        delete_reservation_are_you_sure_title: 'Poistetaanko varaus?',
        delete_role: 'Oletko varma että haluat poistaa roolin?',
        delete_web_user_are_you_sure: 'Oletko varma että haluat poistaa hallintaohjelman käyttäjän?',
        delete_web_user_are_you_sure_title: 'Poistetaanko hallintaohjelman käyttäjä?',
        delete_web_user_alert_recipient_prompt_1:
            'Huom: käyttäjä on asetettu seuraavien sähköpostihälytysten vastaanottajaksi:',
        delete_web_user_alert_recipient_prompt_2:
            'Käyttäjän poistaminen kytkee nämä hälytykset pois päältä kunnes toisen vastaanottaja on asetettu.',
        description: 'Kuvaus',
        doctor: 'Lääkäri',
        doctor_name: 'Lääkärin nimi',
        dosage: 'Annoskoko',
        dosage_tworows: 'Annos-\nkoko',
        dosage_form: 'Lääkemuoto',
        dosage_form_tworows: 'Lääke-\nmuoto',
        dosage_tooltip: 'Määrä + yksikkö',
        drug: 'Huumausainelääke',
        drug_card: 'Huumekortti',
        drug_tworows: 'Huumaus-\nainelääke',
        drugsafe: 'DrugSafe',
        drugsafe_user: 'DrugSafe-käyttäjä',
        drugsafe_user_created: 'DrugSafe-käyttäjä luotu',
        drugsafe_user_deleted: 'DrugSafe-käyttäjä poistettu',
        drugsafe_user_updated: 'DrugSafe-käyttäjä päivitetty',
        drugsafe_structure: 'DrugSafen rakenne',
        drugsafe_users: 'DrugSafe-käyttäjät',
        earliest_expiry_date: 'Aikaisin viimeinen käyttöpäivä',
        edit: 'Muokkaa',
        edit_custom_medication: 'Muokkaa poikkeuslääkettä',
        edit_drugsafe_user: 'Muokkaa DrugSafe-käyttäjää',
        edit_log: 'Muokkaa lokia',
        edit_pharmacy: 'Muokkaa apteekkia',
        edit_reservation: 'Muokkaa varausta',
        edit_web_user: 'Muokkaa hallintaohjelman käyttäjää',
        email: 'Sähköposti',
        email_sent: 'Sähköposti lähetetty',
        error: 'Virhe',
        error_account_temporarily_disabled:
            'Käyttäjätili on väliaikaisesti pois käytöstä. Yritä myöhemmin uudelleen tai ota yhteyttä palvelun ylläpitäjään.',
        error_amount_required: 'Lisää määrä (pakkauksissa ja/tai yksittäisissä kappaleissa)',
        error_cannot_be_negative: 'Arvo ei saa olla negatiivinen',
        error_cannot_edit_signed_log: 'Lokia ei voi muokata koska se on kuitattu.',
        error_confirmation: 'Kentät eivät täsmää',
        error_could_not_check_expiry_alerts: 'Lääkkeiden vanhenemishälytystietojen tarkistus epäonnistui',
        error_could_not_check_pin: 'PIN-koodin tarkistaminen epäonnistui',
        error_could_not_create_custom_medication: 'Poikkeuslääkkeen luominen epäonnistui',
        error_could_not_delete_default_locker: 'Oletuslokeron poisto epäonnistui',
        error_could_not_create_drugsafe_user: 'DrugDafe-käyttäjän luominen epäonnistui',
        error_could_not_create_firebase_auth_user: 'Firebase Authentication -käyttäjän luominen epäonnistui',
        error_could_not_create_login_logout_log: 'Kirjautumislokin luominen epäonnistui',
        error_could_not_create_pharmacy: 'Apteekin luominen epäonnistui',
        error_could_not_create_pin: 'PIN-koodin luominen epäonnistui',
        error_could_not_create_reservation: 'Varauksen luominen epäonnistui',
        error_could_not_create_web_user: 'Hallintaohjelman käyttäjän luominen epäonnistui',
        error_could_not_decrypt: 'Sisällön salauksen purku epäonnistui',
        error_could_not_delete_custom_medication: 'Poikkeuslääkkeen poisto epäonnistui',
        error_could_not_delete_drugsafe_user: 'DrugSafe-käyttäjän poisto epäonnistui',
        error_could_not_delete_firebase_auth_user: 'Firebase Authentication -käyttäjän poisto epäonnistui',
        error_could_not_delete_gtin_vnr_pairs: 'GTIN–VNR-parien poisto epäonnistui',
        error_could_not_delete_medication_alert_config: 'Lääkehälytysasetuksen poisto epäonnistui',
        error_could_not_delete_medications: 'Lääkkeiden poisto epäonnistui',
        error_could_not_delete_old_logs: 'Vanhojen lokien poisto epäonnistui',
        error_could_not_delete_pharmacy: 'Apteekin poisto epäonnistui',
        error_could_not_delete_reservation: 'Varauksen poisto epäonnistui',
        error_could_not_delete_web_user: 'Hallintaohjelman käyttäjän poisto epäonnistui',
        error_could_not_delete_web_users: 'Hallintaohjelman käyttäjien poisto epäonnistui',
        error_could_not_encrypt: 'Sisällön salaaminen epäonnistui',
        error_could_not_generate_password_reset_link: 'Salasananalustuslinkin luonti epäonnistui',
        error_could_not_get_alarms: 'Hälytysten haku epäonnistui',
        error_could_not_get_available_amount: 'Vapaana olevan määrän haku epäonnistui',
        error_could_not_get_custom_medication: 'Poikkeuslääkkeen haku epäonnistui',
        error_could_not_get_custom_medications: 'Poikkeuslääkkeiden haku epäonnistui',
        error_could_not_get_default_locker: 'Oletuslokeron haku epäonnistui',
        error_could_not_get_default_lockers: 'Oletuslokeroiden haku epäonnistui',
        error_could_not_get_drugsafe_config: 'DrugSafe-asetusten haku epäonnistui',
        error_could_not_get_drugsafe_languages: 'DrugSafen kielten haku epäonnistui',
        error_could_not_get_drugsafe_user: 'DrugSafe-käyttäjän haku epäonnistui',
        error_could_not_get_drugsafe_users: 'DrugSafe-käyttäjien haku epäonnistui',
        error_could_not_get_firebase_auth_user: 'Firebase Authentication -käyttäjän haku epäonnistui',
        error_could_not_get_freezes: 'Lukittujen lääkkeiden haku epäonnistui',
        error_could_not_get_gtin_vnr_pairs: 'GTIN–VNR-parien haku epäonnistui',
        error_could_not_get_medication: 'Lääkkeen haku epäonnistui',
        error_could_not_get_medication_alert_config: 'Lääkehälytysasetusten haku epäonnistui',
        error_could_not_get_medication_db_update_date: 'Lääketietokannan päivitysajankohdan haku epäonnistui',
        error_could_not_get_medications: 'Lääkkeiden haku epäonnistui',
        error_could_not_get_log: 'Lokin haku epäonnistui',
        error_could_not_get_logs: 'Lokien haku epäonnistui',
        error_could_not_get_password_reset_link: 'Salasananvaihtolinkin haku epäonnistui',
        error_could_not_get_pharmacies: 'Apteekkien haku epäonnistui',
        error_could_not_get_pharmacy: 'Apteekin haku epäonnistui',
        error_could_not_get_reservation: 'Varauksen haku epäonnistui',
        error_could_not_get_reservations: 'Varausten haku epäonnistui',
        error_could_not_get_role: 'Roolin haku epäonnistui',
        error_could_not_get_roles: 'Roolien haku epäonnistui',
        error_could_not_get_web_user: 'Hallintaohjelman käyttäjän haku epäonnistui',
        error_could_not_get_web_users: 'Hallintaohjelman käyttäjien haku epäonnistui',
        error_could_not_handle_failed_login: 'Epäonnistuneen kirjautumisen käsittely epäonnistui',
        error_could_not_send_email: 'Sähköpostin lähetys epäonnistui',
        error_could_not_set_default_locker: 'Oletuslokeron asettaminen epäonnistui',
        error_could_not_set_gtin_vnr_pairs: 'GTIN–VNR-parien asettaminen epäonnistui',
        error_could_not_set_medications: 'Lääkkeiden asettaminen epäonnistui',
        error_could_not_set_medication_db_update_date: 'Lääketietokannan päivitysajankohdan päivitys epäonnistui',
        error_could_not_update_custom_medication: 'Poikkeuslääkkeen päivitys epäonnistui',
        error_could_not_update_default_locker: 'Oletuslokeron päivitys epäonnistui',
        error_could_not_update_drugsafe_user: 'DrugSafe-käyttäjän päivitys epäonnistui',
        error_could_not_update_firebase_auth_user: 'Firebase Authentication -käyttäjän päivitys epäonnistui',
        error_could_not_update_log: 'Lokin päivitys epäonnistui',
        error_could_not_update_password: 'Salasanan päivitys epäonnistui',
        error_could_not_update_pharmacy: 'Apteekin päivitys epäonnistui',
        error_could_not_update_pin: 'PIN-koodin päivitys epäonnistui',
        error_could_not_update_reservation: 'Varauksen päivitys epäonnistui',
        error_could_not_update_web_user: 'Hallintaohjelman käyttäjän päivitys epäonnistui',
        error_custom_vnr_format: `VNR:n täytyy olla muodossa 'P' + kuusi numeroa, esim. P000001`,
        error_drugsafe_user_not_found: 'DrugSafe-käyttäjää ei löytynyt',
        error_duplicate_vnr: 'Lääke on jo lisätty varaukseen',
        error_email_taken: 'Sähköpostiosoite on jo käytössä',
        error_field_required: 'Pakollinen kenttä',
        error_field_required_if_alert_threshold_specified: 'Kenttä on pakollinen jos hälytysraja on asetettu.',
        error_field_required_if_alert_time_specified: 'Kenttä on pakollinen jos ajankohta on asetettu.',
        error_field_required_if_recipient_specified: 'Kenttä on pakollinen jos vastaanottaja on asetettu.',
        error_invalid_data: 'Data ei hyväksyttävässä muodossa',
        error_login_too_many_attempts:
            'Liian monta väärää kirjautumisyritystä. Yritä myöhemmin uudelleen tai ota yhteyttä palvelun ylläpitäjään.',
        error_login_user_not_found: 'Käyttäjätiliä ei löydy',
        error_login_wrong_password: 'Väärä salasana',
        error_med_name_not_found: 'Lääkettä ei löydy nimellä; yritä etsiä sitä VNR:llä',
        error_must_be_integer: 'Arvon täytyy olla kokonaisluku',
        error_name_vnr_missing: 'Määritä lääkkeen nimi tai VNR',
        error_network_server_error:
            'Yhteys- tai palvelinvirhe. Yritä myöhemmin uudelleen tai ota yhteyttä palvelun ylläpitäjään.',
        error_not_positive: 'Arvon täytyy olla positiivinen',
        error_permission_denied: 'Ei tarvittavia käyttöoikeuksia',
        error_pin_not_unique: 'PIN-koodin täytyy olla uniikki',
        error_prescription_in_use: 'Yksi reseptinumeroista on jo käytössä toisessa varauksessa',
        error_prescription_not_unique: 'Reseptinumeron täytyy olla uniikki',
        error_reservation_locked: 'Varausta ei voi muokata koska se on paraikaa lunastettavana.',
        error_session_expired: 'Istuntosi on päättynyt. Kirjaudu uudelleen sisään.',
        error_supplier_missing: 'Määritä tukku ennen tulostamista',
        error_too_long: 'Pituus saa olla enintään ',
        error_too_short: 'Pituuden täytyy olla vähintään ',
        error_valid_email: 'Validi sähköpostiosoite tarvitaan',
        error_value_too_high: 'Arvo saa olla enintään ',
        error_value_too_low: 'Arvon pitää olla vähintään ',
        error_vnr_not_found: 'VNR:ää ei löydy',
        error_vnr_not_found_in_used_meds: 'VNR-koodille ei löydy tapahtumia.',
        error_vnr_not_found_try_to_get_from_list: 'Hae lääkkeen tiedot lääkelistasta, jos tätä lääkettä käytettiin',
        error_vnr_not_unique: 'VNR:n täytyy olla uniikki',
        error_web_user_inactive: 'Käyttäjätili ei ole aktiivinen. Pyydä pääkäyttäjää aktivoimaan tili.',
        error_web_user_not_found: 'Hallintaohjelman käyttäjää ei löytynyt',
        error_web_user_not_free: 'Hallintaohjelman käyttäjä ei ole vapaana',
        error_wrong_length: 'Pituuden täytyy olla ',
        expiry_alert_recipient_tooltip:
            'Valitse käyttäjä, jonka sähköpostiosoitteeseen vanhenevien lääkkeiden hälytysviestit lähetetään.',
        expiry_alert_time_tooltip: 'Määritä kuinka kauan ennen voimassaolon päättymistä hälytys lähetetään.',
        expiry_alerts: 'Hälytykset vanhenevista lääkkeistä',
        expiry_date: 'Viimeinen käyttöpäivä',
        field: 'Kenttä',
        field_cannot_edit_later: 'Ei voi muokata jälkeenpäin',
        field_required: 'Pakollinen kenttä',
        filter: 'Suodata',
        first_name: 'Etunimi',
        firstname_lastname: 'Etunimi Sukunimi',
        forgot_password: 'Tilaa uusi salasana',
        form: 'Yksikkö',
        from: 'Mistä',
        full_packages_only: 'Älä jaottele täysiä pakkauksia. Jos tämä on valittuna, DrugSafe käsittelee täydet paketit kokonaisina, eikä rakenna kokonaisia paketteja vajaista paketeista.',
        full: 'Lokero vain aukaistu',
        general_info: 'Perustiedot',
        generate: 'Luo',
        generate_pin: 'Luo\xa0PIN',
        global_search: 'Lääkehaku',
        handler: 'Käsittelijä',
        hide_partial_packages: 'Piilota vajaat pakkaukset',
        homepage: 'Kotisivu',
        hours_partitive: 'tuntia',
        id: 'Y-tunnus',
        inactivate_own_web_user_are_you_sure:
            'Oletko varma että haluat asettaa oman hallintaohjelmakäyttäjäsi epäaktiiviseksi? Jos jatkat, sinut kirjataan automaattisesti ulos etkä voi kirjautua sisään ennen kuin tili on uudelleenaktivoitu.',
        inactivate_own_web_user_are_you_sure_title: 'Asetetaanko oma hallintohjelmakäyttäjä epäaktiiviseksi?',
        inactive: 'Ei aktiivinen',
        include_med_in_res_title: 'Sisällytetäänkö lisäämätön lääke?',
        include_med_in_res_text: 'Haluatko sisällyttää lääkkeen MEDNAME varaukseen?',
        information: 'Tieto',
        inventory: 'Varasto',
        inventory_check: 'Saldon tarkistus',
        inventory_correction: 'Saldon korjaus',
        inventory_left: 'Varastossa',
        is_required: 'on pakollinen',
        lang_en: 'englanti',
        lang_fi: 'suomi',
        lang_sv: 'ruotsi',
        language: 'Kieli',
        last_login_date: 'Viimeisin kirjautuminen',
        last_name: 'Sukunimi',
        last_put_in: 'Viimeisin lisäys',
        location: 'Sijainti',
        locker: 'Lokero',
        log: 'Loki',
        log_signed: 'Loki kuitattu',
        log_updated: 'Loki päivitetty',
        login: 'Kirjaudu sisään',
        logo: 'Logo',
        logout: 'Kirjaudu ulos',
        logs_and_alarms: 'Lokit ja hälytykset',
        logs: 'Lokitiedot',
        low_inventory_alert_recipient_tooltip:
            'Valitse käyttäjä, jonka sähköpostiosoitteeseen matalan saldon hälytysviestit lähetetään.',
        low_inventory_alert_threshold: 'Matalan saldon hälytysraja',
        low_inventory_alert_threshold_set: 'Matalan saldon hälytysraja asetettu',
        low_inventory_alert_threshold_tooltip_default:
            'Määritä saldo, jonka kohdalla hälytysviesti lähetetään. Tässä asetettu hälytysraja koskee kaikkia lääkkeitä, joille ei ole asetettu omaa hälytysrajaa. ' +
            'Voit asettaa lääkekohtaisia hälytysrajoja Lääkelista-sivulla.',
        low_inventory_alert_threshold_tooltip_medication_list:
            'Saldo (pakkauksissa), jonka kohdalla hälytysviesti lähetetään. Voit määrittää vastaanottajan ja oletushälytysrajan Minun apteekkini -sivulla.',
        low_inventory_alerts: 'Hälytykset matalasta saldosta',
        mandatory_inventory_check: 'Pakollinen saldon tarkistus',
        mandatory_inventory_check_tooltip: 'Tarkista lääkkeen saldo jokaisen lisäyksen ja oton yhteydessä.',
        marketing_authorization_holder: 'Myyntiluvan haltija',
        marketing_authorization_holder_tworows: 'Myynti-\nluvan haltija',
        medical_center: 'Lääkärikeskus',
        medication: 'Lääke',
        medication_info: 'Lääkkeen tieto',
        medication_list: 'Lääkelista',
        medication_name: 'Lääkkeen nimi',
        medications: 'Lääkkeet',
        meds_in_reservation: 'Varaukseen lisätyt lääkkeet',
        message: 'viesti',
        months: 'kuukautta',
        my_account: 'Tilini',
        my_pharmacy: 'Minun apteekkini',
        name: 'Nimi',
        new_data: 'Uusi data',
        new_password: 'Uusi salasana',
        new_pin: 'Uusi PIN',
        no: 'Ei',
        no_description: 'Ei kuvausta',
        no_logs: 'Ei toimenpiteitä valitulla aikavälillä.',
        no_selection: '(Ei valintaa)',
        none: 'Ei',
        not_available: 'Ei saatavilla',
        ok: 'OK',
        or: 'tai',
        order_new_password: 'Tilaa uusi salasana',
        original: 'alkup.',
        owner: 'Pääkäyttäjä',
        owners: 'Pääkäyttäjät',
        package_long: 'pakkaus',
        package_short: 'pakk',
        package_size: 'Pakkauskoko',
        package_size_tworows: 'Pakkaus-\nkoko',
        packages_left: 'Varastossa',
        packages_long_plural_partitive: 'pakkauksia',
        packages_long_singular_partitive: 'pakkausta',
        packages_pieces_short: 'pakk\xa0(+\xa0kpl)',
        packages_pieces_tooltip: 'Kokonaiset pakkaukset (+\xa0yksittäiset kappaleet suluissa)',
        packages_pieces_tooltip_intro: 'Määrän esitystapa:',
        packages_pieces_tooltip_invcorr:
            '; saldon korjauksissa nuoli ilmaisee muutoksen suunnan (↑\xa0lisäys, ↓\xa0poisto)',
        packages_short_plural_partitive: 'pakk',
        packages_short_singular_partitive: 'pakk',
        page: 'Sivu',
        password: 'Salasana',
        patient_name: 'Asiakkaan nimi',
        per_page: 'Per sivu',
        permission_create_pharmacy: 'Luo apteekki',
        permission_create_user: 'Luo käyttäjä',
        permission_edit_pharmacy: 'Muokkaa apteekkia',
        permission_edit_user: 'Muokkaa käyttäjää',
        permission_show_pharmacy: 'Näytä apteekki',
        permission_show_user: 'Näytä käyttäjä',
        permission_superadmin: 'SUPERADMIN',
        permissions: 'Käyttöoikeudet',
        pharmacies: 'Apteekit',
        pharmacy: 'Apteekki',
        pharmacy_deleted: 'Apteekki poistettu',
        pharmacy_updated: 'Apteekki päivitetty',
        pharmacy_web_users_deleted: 'Apteekin hallintaohjelmakäyttäjät poistettu',
        piece_long: 'yksittäinen kappale',
        piece_short: 'kpl',
        pieces_long_plural_partitive: 'yksittäisiä kappaleita',
        pieces_long_singular_partitive: 'yksittäistä kappaletta',
        pieces_short_singular_partitive: 'kpl',
        pin: 'PIN',
        pincode_confirm: 'Vahvista PIN',
        pincode: 'PIN',
        preferences_updated: 'Asetukset päivitetty',
        prescription: 'Reseptinumero',
        prescription_number_already_in_use: 'Huom: samaa reseptinumeroa käytetty useasti',
        print: 'Tulosta',
        print_close: 'Tulosta viivakoodi ja sulje',
        print_date: 'Tulostusajankohta',
        printed: 'Tulostettu',
        put_in: 'Lääkkeen lisäys',
        recipient: 'Vastaanottaja',
        report: 'Raportti',
        reports: 'Raportit',
        reseller: 'Jälleenmyyjä',
        reseller_tworows: 'Jälleen-\nmyyjä',
        reservation: 'Varauksen lunastus',
        reservation_cannot_set_pills: 'Tälle lääkkeelle ei voi asettaa yksittäisiä kappaleita.',
        reservation_created: 'Varaus luotu',
        reservation_created_for_vnr: 'Varaus luotu VNR:lle',
        reservation_deleted: 'Varaus poistettu',
        reservation_id: 'Varauksen ID',
        reservation_list_info: 'Punaisella merkatut lääkkeet eivät ole vielä saatavana varastossa.',
        reservation_updated: 'Varaus päivitetty',
        reservations: 'Varaukset',
        reserved: 'Varattu',
        reset: 'Tyhjennä',
        role: 'Rooli',
        role_pharmacist: 'Käyttäjä',
        role_pharmacy_owner: 'Pääkäyttäjä',
        role_superadmin: 'Superadmin',
        role_technician: 'Tekninen',
        roles_and_permissions: 'Roolit ja käyttöoikeudet',
        safe_type: 'Laatikostotyyppi',
        salutation: 'Titteli',
        save: 'Tallenna',
        saved: 'Tallennettu',
        search: 'Hae',
        searching: 'Haetaan...',
        select_pharmacy_or_medical_center: 'Valitse joko apteekki tai lääkärikeskus',
        select: 'Valitse',
        send: 'Lähetä',
        session_length: 'Istunnon pituus',
        session_length_tooltip: `Voit halutessasi määrittää, kuinka kauan käyttäjä pysyy sisäänkirjattuna (1–8 tuntia). Jos kenttä on tyhjä, käytetään oletuspituutta (2 tuntia).`,
        set_web_user_are_you_sure:
            'Oletko varma että haluat yhdistää tämän DrugSafe-käyttäjän seuraavaan web-käyttäjään:',
        set_web_user_are_you_sure_title: 'Yhdistetäänkö DrugSafe-käyttäjä web-käyttäjään?',
        show_drugsafe_user: 'Näytä DrugSafe-käyttäjä',
        show_inventory_check_column: `Näytä "Saldon tarkistus" -sarake`,
        show_log: 'Näytä loki',
        show_partial_packages: 'Näytä vajaat pakkaukset',
        show_pharmacy: 'Näytä apteekki',
        show_web_user: 'Näytä hallintaohjelman käyttäjä',
        show: 'Näytä',
        sign: 'Kuittaa',
        sign_log_are_you_sure_text:
            'Oletko varma että haluat kuitata lokin? Kuittauksen jälkeen lokia ei voi enää muokata.',
        sign_log_are_you_sure_title: 'Kuitataanko loki?',
        signed: 'Kuitattu',
        signed_by: 'Kuittaus',
        slug: 'Muuttuja',
        small_no_fridge: 'Pieni ilman jääkaappia',
        small_with_fridge: 'Pieni jääkaapilla',
        status: 'Tila',
        street: 'Katu',
        submit: 'Toimita',
        supplier: 'Toimittaja',
        take_out: 'Lääkkeen otto',
        time_at: 'klo',
        time_period: 'Tarkasteluväli',
        time_period_selection: 'Valitse aikayksikkö',
        time_period_selection_days: 'päivää',
        time_period_selection_months: 'kuukautta',
        time_period_selection_weeks: 'viikkoa',
        to: 'Mihin',
        two_d_codes: '2D-koodit',
        type: 'Toiminto',
        update_account: 'Muuta tilitietoja',
        update_drug_card_inv_check_col_common_text: `Voit vaihtaa sarakkeen näkyvyyden myös huumekortin ulkoasuasetuksista.`,
        update_drug_card_inv_check_col_hide_text: `Olet ottanut pakollisen saldon tarkistuksen pois päältä, mutta "Saldon tarkistus" -sarake on tällä hetkellä näkyvissä huumekortilla. Haluatko piilottaa sarakkeen?`,
        update_drug_card_inv_check_col_hide_title: `Piilota "Saldon tarkitus" -sarake huumekortilla?`,
        update_drug_card_inv_check_col_show_text: `Olet laittanut pakollisen saldon tarkistuksen päälle, mutta "Saldon tarkistus" -sarake on tällä hetkellä piilotettu huumekortilla. Haluatko näyttää sarakkeen?`,
        update_drug_card_inv_check_col_show_title: `Näytä "Saldon tarkitus" -sarake huumekortilla?`,
        update_reservation: 'Päivitä varaus',
        updated_at: 'Päivitetty',
        users: 'Käyttäjät',
        users_amount: 'Käyttäjiä',
        users_data: 'Käyttäjätiedot',
        value: 'Arvo',
        view_individual_meds_same_column: 'Pakkaukset ja yksittäiset kappaleet samassa sarakkeessa',
        view_individual_meds_separate_column: 'Pakkaukset ja yksittäiset kappaleet eri sarakkeissa',
        vnr: 'VNR',
        web_user: 'Hallintaohjelman käyttäjä',
        web_user_created: 'Hallintaohjelman käyttäjä luotu',
        web_user_deleted: 'Hallintaohjelman käyttäjä poistettu',
        web_user_updated: 'Hallintaohjelman käyttäjä päivitetty',
        web_users: 'Web-käyttäjät',
        yes: 'Kyllä',
        zip: 'Postinumero',
        error_switch_to_syke_mode: 'Switch to new Webtool link https://drugsafe-remomedi-syke.web.app',

        many_incorrect_logins: 'Liian monta väärää kirjautumisyritystä',
        enable_account: 'Ota tili käyttöön',
        activate_account: 'Aktivoi tili',
        deactivated: 'Ei käytössä',
        minutes_partitiv: 'pöytäkirja',

        take_out_action_may_be_destroy_of_medication: 'Jos tässä lääkkeen otossa oli kyse lääkkeen hävittämisestä, merkitse se hävitetyksi ja kuittaa. HUOM! Asiakkaan ja lääkärin nimi sekä reseptinumero tulee jättää tyhjiksi lokissa',
        i_give_consent_that_i_mark_action_as_destroy: 'Täten vahvistan, että merkitsen tämän tapahtuman lääkkeen hävittämiseksi',
        update_and_sign: 'Päivitä lokitapahtumaksi lääkkeen hävittäminen & kuittaus',
        mark_log_as_destroyed_title: 'Oletko varma että haluat merkitä tämän lokitapahtuman lääkkeen hävittämiseksi?',
        mark_log_as_destroyed_question: 'Huom! Tämä toiminto on peruuttamaton. Oletko varma että haluat merkitä tämän lokitapahtuman lääkkeen hävittämiseksi? Toimintoa ei voi peruuttaa jälkikäteen .',
        error_cannot_edit_destroyed_log: 'Lokitapahtumaa ei voi muokata, koska se merkitty hävitetyksi.',
        error_cannot_edit_signed_and_marked_log: 'Lokitapahtumaa ei voi muokata, koska se merkitty hävitetyksi ja kuitatuksi.',
        mark_destroy_user_and_time: 'Päivä&Aika, Käyttäjä joka merkitsi ja kuittasi lääkkeen hävityksen',
        comments_to_destroyed_drugs: 'Täydennä vasemmalla sijaitsevaan kommentti- kenttään toiminnon kuvaus',


        additional_modules: 'Laajennusosat',
        add_module: 'Lisää laajennusosa',
        choose_module_to_remove: 'Valitse poistettava laajennusosa',
        remove_module: 'Poista laajennusosa',
        remove: 'Poista',
        error_could_not_change_structure_medication_in_locker: 'Laajennusosa sisältää lääkkeitä. Ei voida poistaa'
    },
    sv: {
        account: 'Konto',
        account_updated: 'Konto uppdaterat',
        activate: 'Aktivera',
        active: 'Aktiv',
        add_another_medication: 'Lägg till en annan medicin',
        add_comment: 'Kommentar',
        add_comment_to_log: 'Lägg till kommentar till logghändelse',
        add_drugsafe_user: 'Lägg till DrugSafe-användare',
        add_medication: 'Lägg till medicin',
        add_time: 'Lägg till tid',
        add_to_reservation: 'Lägg till reservation',
        alarm_email: 'E-post för varning',
        alarm_phone: 'Telefonnummer för varning',
        alarm: 'Varning',
        alarms: 'Varning',
        alert_expires_in_less_than: 'Utgår i under ',
        alert_low_inventory: 'Lågt lagersaldo',
        alert_threshold: 'Varningsgräns',
        alert_time: 'Varningsgräns',
        all: 'Alla',
        amount: 'Kvantitet',
        amount_added: 'Tillagd',
        amount_locker: 'I facket',
        amount_taken: 'Uttaget',
        appear_soon: 'Väntar PIN',
        atc: 'ATC-kod',
        available: 'Tillgänglig',
        back: 'Tillbaka',
        before_expiry: 'före utgång',
        big_no_fridge: 'Stor, ingen kyl',
        big_with_fridge: 'Stor med kyl',
        business_id: 'Företags-id',
        cancel: 'Avbryt',
        careful: 'Försiktig',
        center: 'Central',
        center_type: 'Centraltyp',
        change: 'Korrigera lager',
        change_password_drugsafeuser: 'DrugSafe PIN',
        change_password_webuser: 'WebTool kontolösenord',
        changes: 'Ändringar',
        check: 'Lagerkontroll',
        chemical: 'Aktiv substans',
        choose_layout: 'Välj layout',
        city: 'Stad',
        client: 'Kund',
        client_name: 'Kundens namn',
        close: 'Stäng',
        comments: 'Kommentarer',
        confirm: 'Bekräfta',
        confirm_new_password: 'Bekräfta nytt lösenord',
        confirm_new_pin: 'Bekräfta ny PIN',
        confirm_password: 'Bekräfta lösenord',
        correction_legend: 'Korrigeringar markeras med en asterisk (*); ursprungligt värde inom parenteser.',
        country: 'Land',
        create: 'Skapa',
        create_custom_medication: 'Skapa undantagsprodukt',
        create_drugsafe_user: 'Skapa DrugSafe-användare',
        create_only_drugsafe_user: 'Skapa enbart DrugSafe-användare',
        create_only_web_user: 'Skapa enbart webtool-användare',
        create_pharmacy: 'Skapa apotek',
        create_reservation: 'Skapa reservation',
        create_user: 'Skapa användare',
        create_web_and_drugsafe_users: 'Skapa webtool och DrugSafe-användare',
        create_web_user: 'Skapa webtool-användare',
        created: 'Skapad',
        created_at: 'Användare skapad',
        current_inventory: 'Lagersaldo vid tidpunkt för utskrift:',
        current_password: 'Nuvarande lösenord',
        current_pin: 'Nuvarande PIN',
        custom_medication_cannot_delete_in_use:
            'Denna undantagsprodukt kan inte raderas eftersom den redan tagits i bruk.',
        custom_medication_cannot_edit_in_use: 'Denna undantagsprodukt kan inte ändras eftersom den redan tagits i bruk.',
        custom_medication_created: 'Undantagsprodukt skapad',
        custom_medication_deleted: 'Undantagsprodukt raderad',
        custom_medication_updated: 'Undantagsprodukt uppdaterad',
        custom_medication_vnr_tooltip: `P + sex siffror, t.ex. P000001`,
        custom_medications: 'Undantagsprodukt',
        dashboard: 'Instrumentbräda',
        date: 'Datum',
        days: 'dagar',
        deactivate: 'Deaktivera',
        default_locker: 'Standardfack',
        default_locker_not_set: 'Standardfack inte angivet',
        default_locker_set: 'Standardfack inställt',
        default_lockers: 'Standardfack',
        default_lockers_tooltip: `Spara medicin' standardfack i minnet. När denna inställning är påkopplad hjälper DrugSafe användaren att lägga till varje medicin i rätt fack. Standardfack kan ändras på sidan Medicinlista`,
        delete: 'Ta bort',
        delete_custom_medication_are_you_sure_text: 'Är du säker på att du vill radera denna undantagsprodukt?',
        delete_custom_medication_are_you_sure_title: 'Radera undantagsprodukt?',
        delete_drugsafe_user_are_you_sure: 'Är du säker att du vill radera denna DrugSafe-användare?',
        delete_drugsafe_user_are_you_sure_title: 'Radera DrugSafe-användare?',
        delete_old_logs: 'Automatisk radering av gamla logghändelser',
        delete_old_logs_are_you_sure_text: `Du har kopplat på automatisk radering av gamla logghändelser. Loggar som är äldre än den kortaste lagstadgade förvaringsperioden kommer att raderas permanent. Är du säker att du vill fortsätta?.`,
        delete_old_logs_are_you_sure_title: 'Koppla på automatisk radering av gamla logghändelser?',
        delete_old_logs_tooltip:
            'Om denna inställning är på raderas logghändelser som är äldre än den kortaste lagstadgade förvaringsperioden (sex hela kalenderår) permanent.',
        delete_own_web_user_are_you_sure: `Är du säker att du vill radera din egna webtool-användare? If you proceed, you will be automatically logged out and won't be able to log in again.`,
        delete_own_web_user_are_you_sure_title: 'Radera egen webtool-användare?',
        delete_pharmacy_are_you_sure_text: 'Är du säker att du vill radera detta apotek och alla dess webtool-användare?',
        delete_pharmacy_are_you_sure_title: 'Ta bort apotek?',
        delete_reservation_are_you_sure_text: 'Är du säker att du vill radera denna reservation?',
        delete_reservation_are_you_sure_title: 'Radera reservation?',
        delete_role: 'Är du säker att du vill radera denna roll?',
        delete_web_user_are_you_sure: 'Är du säker att du vill radera denna webtool-användare?',
        delete_web_user_are_you_sure_title: 'Ta bort webtool-användare?',
        delete_web_user_alert_recipient_prompt_1:
            'Obs: användaren är för närvarande inställd som mottagare för följande e-postvarningar:',
        delete_web_user_alert_recipient_prompt_2:
            'Radering av denna användare kommer att ta dessa varningar ur bruk tills en ny mottagare anges.',
        description: 'Beskrivning',
        doctor: 'Läkare',
        doctor_name: 'Läkarens namn',
        dosage: 'Dosering',
        dosage_tworows: 'Dosering',
        dosage_form: 'Doseringsform',
        dosage_form_tworows: 'Doseringsform',
        dosage_tooltip: 'Mängd + enhet',
        drug: 'Narkotika',
        drug_card: 'Medicinkort',
        drug_tworows: 'Medicin',
        drugsafe: 'DrugSafe',
        drugsafe_structure: 'DrugSafe struktur',
        drugsafe_user: 'DrugSafe-användare',
        drugsafe_user_created: 'DrugSafe-användare skapad',
        drugsafe_user_deleted: 'DrugSafe-användare raderad',
        drugsafe_user_updated: 'DrugSafe-användare uppdaterad',
        drugsafe_users: 'DrugSafe-användare',
        earliest_expiry_date: 'Tidigaste utgångsdatum',
        edit: 'Redigera',
        edit_custom_medication: 'Redigera undantagsprodukt',
        edit_drugsafe_user: 'Redigera DrugSafe-användare',
        edit_log: 'Redigera logg',
        edit_pharmacy: 'Redigera apotek',
        edit_reservation: 'Redigera reservation',
        edit_web_user: 'Redigera webtool-användare',
        email: 'E-post',
        email_sent: 'E-post skickad',
        error: 'Fel',
        error_account_temporarily_disabled:
            'Kontot är tilfälligt ur bruk. Försök på nytt senare eller kontakta administratören.',
        error_amount_required: 'Ange antal (i förpackningar och/eller enskilda artiklar)',
        error_cannot_be_negative: 'Värdet kan inte vara negativt',
        error_cannot_edit_signed_log: 'Logghändelsen kan inte redigeras efter att den bekräftats.',
        error_confirmation: 'Värden stämmer inte',
        error_could_not_check_expiry_alerts: 'Medicinernas utgångsvarningsinformation kunde inte hämtas.',
        error_could_not_check_pin: 'PIN kunde inte kontrolleras',
        error_could_not_create_custom_medication: 'Undantagsprodukt kunde inte skapas',
        error_could_not_create_drugsafe_user: 'DrugSafe-användare kunde inte skapas',
        error_could_not_create_firebase_auth_user: 'Firebase Authentication-användare kunde inte skapas',
        error_could_not_create_login_logout_log: 'In/utloggningslogg kunde inte skapas',
        error_could_not_create_pharmacy: 'Apotek kunde inte skapas',
        error_could_not_create_pin: 'PIN kunde inte skapas',
        error_could_not_create_reservation: 'Reservation kunde inte skapas',
        error_could_not_create_web_user: 'Webtool-användare kunde inte skapas',
        error_could_not_decrypt: 'Innehållsdekryptering misslyckades',
        error_could_not_delete_custom_medication: 'Undantagsprodukt kunde inte skapas',
        error_could_not_delete_default_locker: 'Standardfack kunde inte raderas',
        error_could_not_delete_firebase_auth_user: 'Firebase Authentication-användare kunde inte raderas',
        error_could_not_delete_gtin_vnr_pairs: 'GTIN–VNR- par kunde inte raderas',
        error_could_not_delete_medication_alert_config: 'Medicinvarningskonfiguration kunde inte raderas',
        error_could_not_delete_medications: 'Mediciner kunde inte raderas',
        error_could_not_delete_old_logs: 'Gamla logghändelser kunde inte raderas',
        error_could_not_delete_pharmacy: 'Apotek kunde inte raderas',
        error_could_not_delete_drugsafe_user: 'DrugSafe-användare kunde inte raderas',
        error_could_not_delete_reservation: 'Reservation kunde inte raderas',
        error_could_not_delete_web_user: 'WebTool-användare kunde inte raderas',
        error_could_not_delete_web_users: 'WebTool-användare kunde inte raderas',
        error_could_not_encrypt: 'Kryptering av innehåll misslyckades',
        error_could_not_generate_password_reset_link: 'Länk för återställning av lösenord kunde inte skapas',
        error_could_not_get_alarms: 'Larm kunde inte hämtas',
        error_could_not_get_available_amount: 'Tillgänglig mängd kunde inte hämtas',
        error_could_not_get_custom_medication: 'Undantagsprodukt kunde inte hämtas',
        error_could_not_get_custom_medications: 'Undantagsprodukter kunde inte hämtas',
        error_could_not_get_default_locker: 'Standardfack kunde inte hämtas',
        error_could_not_get_default_lockers: 'Standardfack kunde inte hämtas',
        error_could_not_get_drugsafe_config: 'DrugSafe-konfiguration kunde inte hämtas',
        error_could_not_get_drugsafe_languages: 'DrugSafe-språk kunde inte hämtas',
        error_could_not_get_drugsafe_user: 'DrugSafe-användare kunde inte hämtas',
        error_could_not_get_drugsafe_users: 'DrugSafe-användare kunde inte hämtas',
        error_could_not_get_firebase_auth_user: 'Firebase Authentication-användare kunde inte hämtas',
        error_could_not_get_freezes: 'Låsta mediciner kunde inte hämtas',
        error_could_not_get_gtin_vnr_pairs: 'GTIN–VNR- par kunde inte hämtas',
        error_could_not_get_log: 'Logg kunde inte hämtas',
        error_could_not_get_logs: 'Logghändelser kunde inte hämtas',
        error_could_not_get_medication: 'Medicin kunde inte hämtas',
        error_could_not_get_medication_alert_config: 'Konfiguration för medicinvarningar kunde inte hämtas',
        error_could_not_get_medication_db_update_date: 'Medicindatabasens uppdateringsdatum kunde inte hämtas',
        error_could_not_get_medications: 'Mediciner kunde inte hämtas',
        error_could_not_get_password_reset_link: 'Länk för återställning av lösenord kunde inte hämtas',
        error_could_not_get_pharmacies: 'Apotek kunde inte hämtas',
        error_could_not_get_pharmacy: 'Apotek kunde inte hämtas',
        error_could_not_get_reservation: 'Reservationen kunde inte hämtas',
        error_could_not_get_reservations: 'Reservationer kunde inte hämtas',
        error_could_not_get_role: 'Roll kunde inte hämtas',
        error_could_not_get_roles: 'Roller kunde inte hämtas',
        error_could_not_get_web_user: 'WebTool-användare kunde inte hämtas',
        error_could_not_get_web_users: 'WebTool-användare kunde inte hämtas',
        error_could_not_handle_failed_login: 'Misslyckad inloggning kunde inte hanteras',
        error_could_not_send_email: 'E-post gick inte att skicka',
        error_could_not_set_default_locker: 'Standardfack kunde inte anges',
        error_could_not_set_gtin_vnr_pairs: 'GTIN–VNR- par kunde inte anges',
        error_could_not_set_medications: 'Mediciner kunde inte anges',
        error_could_not_set_medication_db_update_date: 'Datum för medicindatabasens uppdatering kunde inte anges',
        error_could_not_update_custom_medication: 'Undantagsprodukt kunde inte uppdateras',
        error_could_not_update_default_locker: 'Standardfack kunde inte uppdateras',
        error_could_not_update_drugsafe_user: 'DrugSafe-användare kunde inte uppdateras',
        error_could_not_update_firebase_auth_user: 'Firebase Authentication-användare kunde inte uppdateras',
        error_could_not_update_log: 'Logg kunde inte uppdateras',
        error_could_not_update_password: 'Lösenord kunde inte uppdateras',
        error_could_not_update_pharmacy: 'Apotek kunde inte uppdateras',
        error_could_not_update_reservation: 'Reservation kunde inte uppdateras',
        error_could_not_update_pin: 'PIN kunde inte uppdateras',
        error_could_not_update_web_user: 'Webtool-användare kunde inte uppdateras',
        error_custom_vnr_format: `VNR måste anges som 'P' följt av sex siffror, t.ex. P000001`,
        error_drugsafe_user_not_found: 'Ingen användare hittad',
        error_duplicate_vnr: 'Medicinen finns redan på reservationen',
        error_email_taken: 'E-postadressen är redan i användning',
        error_field_required: 'Nödvändigt fält',
        error_field_required_if_alert_threshold_specified: 'Fältet är nödvändigt om en varningsgräns är angiven.',
        error_field_required_if_alert_time_specified: 'Fältet är nödvändigt om en varningstid är angiven.',
        error_field_required_if_recipient_specified: 'Fältet är nödvändigt om en mottagare är angiven.',
        error_invalid_data: 'Ogiltig information',
        error_login_too_many_attempts:
            'För många felaktiga inloggningsförsök. Försök på nytt senare, eller kontakta administratören.',
        error_login_user_not_found: 'Användarkonto hittades ej',
        error_login_wrong_password: 'Fel lösenord',
        error_med_name_not_found: 'Medicin hittades ej med namn; försök leta med VNR',
        error_must_be_integer: 'Värdet måste vara ett heltal',
        error_name_vnr_missing: 'Ange medicinens namn eller VNR',
        error_network_server_error:
            'Nätverk- eller serverfel. Försök på nytt senare, eller kontakta administratören.',
        error_not_positive: 'Värdet måste vara positivt',
        error_permission_denied: 'Åtkomst nekad',
        error_pin_not_unique: 'PIN måste vara unik',
        error_prescription_in_use: 'Ett av receptnummren är redan i bruk i en annan reservation',
        error_prescription_not_unique: 'Receptnummer måste vara unikt',
        error_reservation_locked: 'Reservationen kan inte ändras eftersom den för närvarand görs anspråk på.',
        error_session_expired: 'Din session har gått ut. Vänligen logga in på nytt.',
        error_supplier_missing: 'Ange partihandel före utskrift',
        error_too_long: 'Längd kan som mest vara ',
        error_too_short: 'Längd måste vara åtminstone ',
        error_valid_email: 'Måste vara en giltig e-postadress',
        error_value_too_high: 'Värdet kan som mest vara ',
        error_value_too_low: 'Värdet måste åtminstone vara ',
        error_vnr_not_found: 'VNR hittades inte',
        error_vnr_not_found_in_used_meds: 'Inga händelser hittade för VNR.',
        error_vnr_not_found_try_to_get_from_list: 'Försök hitta information om medicinen från medicinlistan om denna VNR använts.',
        error_vnr_not_unique: 'VNR måste vara unik',
        error_web_user_inactive: 'Användardkontot är inte aktivt. Vänligen be en administratör aktivera kontot.',
        error_web_user_not_found: 'WebTool-användare hittades ej',
        error_web_user_not_free: 'WebTool-användare är inte ledig',
        error_wrong_length: 'Längden måste vara ',
        expiry_alert_recipient_tooltip: 'Välj användare som varnings e-post om utgående mediciner skickas till.',
        expiry_alert_time_tooltip: 'Ange hur länge före utgång varningen skickas.',
        expiry_alerts: 'Varning för utgående medicin',
        expiry_date: 'Utgångsdatum',
        field: 'Fält',
        field_cannot_edit_later: 'Kan inte redigeras senare',
        field_required: 'Nödvändigt fält',
        filter: 'Filter',
        first_name: 'Förnamn',
        firstname_lastname: 'Förnamn Efternamn',
        forgot_password: 'Beställ nytt lösenord',
        form: 'Enhet',
        from: 'Från',
        full_packages_only: 'Dela inte hela förpackningar. Kryssa om du vill att DrugSafe inte delar upp hela förpackningar för att ge ut enskila mediciner.',
        full: 'Facket öppnas bara',
        general_info: 'Allmänn information',
        generate: 'Skapa',
        generate_pin: 'Skapa\xa0PIN',
        global_search: 'Medicinsökning',
        handler: 'Handläggare',
        hide_partial_packages: 'Göm delförpackningar',
        homepage: 'Hemsida',
        hours_partitive: 'timmar',
        id: 'ID',
        inactivate_own_web_user_are_you_sure: `Är du säker att du vill inaktivera ditt webtool-konto? Om du fortsätter loggas du ut automatiskt, och kommer inte att kunna logga in på nytt före kontot åter är aktiverat.`,
        inactivate_own_web_user_are_you_sure_title: 'Inaktivera egen webtool-användare?',
        inactive: 'Inaktiv',
        include_med_in_res_title: 'Inkludera otillagd medicin?',
        include_med_in_res_text: 'Vill du inkludera medicinen MEDNAME i reservationen?',
        information: 'Information',
        inventory: 'Lager',
        inventory_check: 'Lagerkontroll',
        inventory_correction: 'Lagerkorrigering',
        inventory_left: 'Lager',
        is_required: 'krävs',
        lang_en: 'Engelska',
        lang_fi: 'Finska',
        lang_sv: 'Svenska',
        language: 'Språk',
        last_login_date: 'Senaste inloggningsdatum',
        last_name: 'Efternamn',
        last_put_in: 'Latest put\xa0in',
        location: 'Plats',
        locker: 'Fack',
        log: 'Logg',
        log_signed: 'Logghändelse bekräftad',
        log_updated: 'Logghändelse uppdaterad',
        login: 'Logga in',
        logo: 'Logo',
        logout: 'Logga ut',
        logs_and_alarms: 'Logghändelser och varningar',
        logs: 'Logghändelser',
        low_inventory_alert_recipient_tooltip: 'Välj användare som varningar om låg lagernivå skickas till.',
        low_inventory_alert_threshold: 'Gräns för lagernivåvarning',
        low_inventory_alert_threshold_set: 'Lagernivåvarning har ställts in',
        low_inventory_alert_threshold_tooltip_default:
            'Ange lagernivån vid vilken en varning skickas. Denna gräns berör all medicin som inte har angetts en egen gräns. ' +
            'Du kan ange medicinspecifika varningsgränser på sidan Medicinlista.',
        low_inventory_alert_threshold_tooltip_medication_list:
            'Lagersaldo (i förpackningar) som orsakar att en varning skickas. Du kan specificera mottagaren och standardgräns för varningar på sidan Mitt apotek.',
        low_inventory_alerts: 'Varning för lågt lagersaldo',
        mandatory_inventory_check: 'Obligatorisk lagerkontroll',
        mandatory_inventory_check_tooltip: `Kontrollera medicinens lagernivå varje gång den tas ut eller läggs till.`,
        marketing_authorization_holder: 'Innehavare av försäljningstillstånd',
        marketing_authorization_holder_tworows: 'Innehavare av försäljningstillstånd',
        medical_center: 'Sjukhus',
        medication: 'Medicin',
        medication_info: 'Medicininfo',
        medication_list: 'Medicinlista',
        medication_name: 'Medicinens namn',
        medications: 'Mediciner',
        meds_in_reservation: 'Mediciner i reservationen',
        message: 'meddelande',
        months: 'månader',
        my_account: 'Mitt konto',
        my_pharmacy: 'Mitt apotek',
        name: 'Namn',
        new_data: 'Ny data',
        new_password: 'Nytt lösenord',
        new_pin: 'Ny PIN',
        no: 'Nej',
        no_description: 'Ingen beskrivning',
        no_logs: 'Inga händelser under vald tidsperiod.',
        no_selection: '(Inget val)',
        none: 'Inga',
        not_available: 'Inte tillgänglig just nu',
        ok: 'OK',
        or: 'eller',
        order_new_password: 'Beställ nytt lösenord',
        original: 'ursprungligt',
        owner: 'Ägare',
        owners: 'Ägare',
        package_long: 'förpackning',
        package_short: 'Förp',
        package_size: 'Förpackningsstorlek',
        package_size_tworows: 'Förpackningsstorlek',
        packages_left: 'Lager',
        packages_long_plural_partitive: 'förpackningar',
        packages_long_singular_partitive: 'förpackningar',
        packages_pieces_short: 'förp\xa0(+\xa0st)',
        packages_pieces_tooltip: 'Hela förpackningar (+\xa0enskilda artiklar inom parenteser)',
        packages_pieces_tooltip_intro: 'Format för visning av mängd:',
        packages_pieces_tooltip_invcorr:
            '; för lagerkorrigering, pilen indikerar åt vilket håll ändringen sker (↑\xa0öka, ↓\xa0minska)',
        packages_short_plural_partitive: 'förp',
        packages_short_singular_partitive: 'förp',
        page: 'Sida',
        password: 'Lösenord',
        patient_name: 'Kundnamn',
        per_page: 'Per sida',
        permission_create_pharmacy: 'Skapa apotek',
        permission_create_user: 'Skapa användare',
        permission_edit_pharmacy: 'Redigera apotek',
        permission_edit_user: 'Redigera användare',
        permission_show_pharmacy: 'Visa apotek',
        permission_show_user: 'Visa användare',
        permission_superadmin: 'SUPERADMIN',
        permissions: 'Lov',
        pharmacies: 'Apotek',
        pharmacy: 'Apotek',
        pharmacy_deleted: 'Apotek raderat',
        pharmacy_updated: 'Apotek uppdaterat',
        pharmacy_web_users_deleted: `Apotekets webtool-användare raderad`,
        piece_long: 'Enskilda artiklar',
        piece_short: 'art',
        pieces_long_plural_partitive: 'enskilda artiklar',
        pieces_long_singular_partitive: 'enskild artikel',
        pieces_short_singular_partitive: 'art',
        pin: 'PIN',
        pincode: 'PIN',
        pincode_confirm: 'Bekräfta PIN',
        preferences_updated: 'Preferensser uppdaterade',
        prescription: 'Receptnummer',
        prescription_number_already_in_use: 'Obs: samma receptnummer har använts flera gånger',
        print: 'Skriv ut',
        print_close: 'Skriv ut streckkod och stäng',
        print_date: 'Utskriftsdatum',
        printed: 'Utskriven',
        put_in: 'Lägg till medicin',
        recipient: 'Mottagare',
        report: 'Rapport',
        reports: 'Rapporter',
        reseller: 'Återförsäljare',
        reseller_tworows: 'Återförsäljare',
        reservation: 'Hämta reservation',
        reservation_cannot_set_pills: 'Enskilda artiklar kan inte ställas in för denna medicin.',
        reservation_created: 'Reservation skapad',
        reservation_created_for_vnr: 'Reservation skapad för VNR',
        reservation_deleted: 'Reservation raderad',
        reservation_id: 'Reservations-ID',
        reservation_list_info: 'Artiklar i rött är för närvarande inte tillgängliga i lagret.',
        reservation_updated: 'Reservation uppdaterad',
        reservations: 'Reservationer',
        reserved: 'Reserverad',
        reset: 'Nollställ',
        role: 'Roll',
        role_pharmacist: 'Användare',
        role_pharmacy_owner: 'Administratör',
        role_superadmin: 'Superadmin',
        role_technician: 'Teknisk',
        roles_and_permissions: 'Roller och behörigheter',
        safe_type: 'DrugSafe-typ',
        salutation: 'Hälsning',
        save: 'Spara',
        saved: 'Sparad',
        search: 'Sök',
        searching: 'Söker...',
        select_pharmacy_or_medical_center: 'Välj apotek eller sjukhus',
        select: 'Välj',
        send: 'Skicka',
        session_length: 'Sessionslängd',
        session_length_tooltip: `Du kan ange hur länge användaren hålls inloggad (1–8 timmar). Om fältet lämnas tomt används standard inloggningstid (2 timmar).`,
        set_web_user_are_you_sure: 'Är du säker att du vill koppla denna DrugSafe-användare till följande webtool-användare:',
        set_web_user_are_you_sure_title: 'Koppla DrugSafe-användare till webtool-användare?',
        show_drugsafe_user: 'Visa DrugSafe-användare',
        show_inventory_check_column: `Visa "Lagerkontroll"-kolumnen`,
        show_log: 'Visa logg',
        show_partial_packages: 'Visa delförpackningar',
        show_pharmacy: 'Visa apotek',
        show_web_user: 'Visa webtool-användare',
        show: 'Visa',
        sign: 'Bekräfta',
        sign_log_are_you_sure_text:
            'Är du säker att du vill bekräfta denna logg? Efter signering kan loggen inte redigeras.',
        sign_log_are_you_sure_title: 'Bekräfta logg?',
        signed: 'Bekräftad',
        signed_by: 'Bekräftad av',
        slug: 'Slug',
        small_no_fridge: 'Liten, ingen kyl',
        small_with_fridge: 'Liten med kyl',
        status: 'Status',
        street: 'Gata',
        submit: 'Skicka',
        supplier: 'Partihandel',
        take_out: 'Ta ut medicin',
        time_at: 'vid',
        time_period: 'Tidsperiod',
        time_period_selection: 'Välj tidsenhet',
        time_period_selection_days: 'dagar',
        time_period_selection_months: 'månader',
        time_period_selection_weeks: 'veckor',
        to: 'Till',
        two_d_codes: '2D-koder',
        type: 'Åtgärd',
        update_account: 'Uppdatera kontoinformation',
        update_drug_card_inv_check_col_common_text: `Du kan också ställa in kolumnsynlighet i layoutinställningarna för medicinkortet.`,
        update_drug_card_inv_check_col_hide_text: `Du har kopplat av den obligatoriska lagerkontrollen, men "Lagerkontroll"-kolumnen visas fortfarande på medicinkortet. Vill du dölja denna kolumn?`,
        update_drug_card_inv_check_col_hide_title: `Dölj "Lagerkontroll"-kolumn på medicinkort?`,
        update_drug_card_inv_check_col_show_text: `Du har kopplat på den obligatoriska lagerkontrollen, men "Lagerkontroll"-kolumnen visas inte på medicinkortet. Vill du visa denna kolumn?`,
        update_drug_card_inv_check_col_show_title: `Visa "Lagerkontroll"-kolumn på medicinkort?`,
        update_reservation: 'Uppdatera reservation',
        updated_at: 'Uppdaterad',
        users: 'Användare',
        users_amount: 'Användare',
        users_data: 'Användardata',
        value: 'Värde',
        view_individual_meds_same_column: 'Förpackningar och enskilda artiklar i samma kolumn',
        view_individual_meds_separate_column: 'Förpackningar och enskilda artiklar i skilda kolumner',
        vnr: 'VNR',
        web_user: 'Webtool-användare',
        web_user_created: 'Webtool-användare skapad',
        web_user_deleted: 'Webtool-användare raderad',
        web_user_updated: 'Webtool-användare uppdaterad',
        web_users: 'Webtool-användare',
        yes: 'Ja',
        zip: 'Postnummer',
        error_switch_to_syke_mode: 'Byt till den nya webtool-länken https://drugsafe-remomedi.web.app/login',
        many_incorrect_logins: 'Många felaktiga inloggningar',
        enable_account: 'Ta i bruk konto',
        activate_account: 'Aktivera konto',
        deactivated: 'Inaktivera',
        minutes_partitive: 'minuter',

        take_out_action_may_be_destroy_of_medication: 'Om detta uttag gjordes för att bortskaffa medicin, vänligen markera den som bortskaffad och bekräfta. Obs! Logghändelsens kund, doktor- samt receptfält bör vara tomma.',
        i_give_consent_that_i_mark_action_as_destroy: 'Jag ger uttryckligen mitt samtycke till att jag markerar detta uttag som en åtgärd för att bortskaffa medicin',
        update_and_sign: 'Uppdatera logghändelse som bortskaffning & Bekräfta',
        mark_log_as_destroyed_title: 'Är du säker att du vill markera denna logghändelse som en bortskaffning av medicin?',
        mark_log_as_destroyed_question: 'Obs! Denna åtgärd är oåterkallelig. Är du säker på att du vill markera detta uttag av medicin som en logghändelse över bortskaffning? Du kan inte avbryta denna åtgärd senare.',
        error_cannot_edit_destroyed_log: 'Logghändelsen kan inte redigeras eftersom den has markerats som bortskaffning.',
        error_cannot_edit_signed_and_marked_log: 'Logghändelsen kan inte redigeras eftersom den har markerats som förstörd och bekräftad.',
        mark_destroy_user_and_time: 'Datum&Tid, Användare som markerade bortskaffning av medicin',
        comments_to_destroyed_drugs: 'Vänligen använd kommentarsfälten till vänster för att lägga till en beskrivning av åtgärden.',

        additional_modules: 'Ytterligare moduler',
        add_module: 'Lägg till modul',
        choose_module_to_remove: 'Välj modul att ta bort',
        remove_module: 'Ta bort modul',
        remove: 'Ta bort',
        error_could_not_change_structure_medication_in_locker: 'Apoteket har lager i denna modul. Den kan icke borttas.'
    }
};
